import { render, staticRenderFns } from "./AuthFormContainer.vue?vue&type=template&id=20c5918a&lang=pug&"
import script from "./AuthFormContainer.vue?vue&type=script&lang=ts&"
export * from "./AuthFormContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports